import {useQuery} from '@tanstack/react-query'
import axios from 'axios'

export const useOnlineOrderData = () => {
  const dataUrl = 'http://localhost:3005/orders'
  const columnUrl = 'http://localhost:3006/columns'

  const rowQuery = useQuery({
    queryKey: ['onlineRowData', dataUrl],
    queryFn: async () => {
      const {data} = await axios.get(dataUrl)
      return data
    },
  })

  const colQuery = useQuery({
    queryKey: ['onlineColConfig', columnUrl],
    queryFn: async () => {
      const {data} = await axios.get(columnUrl)
      return data
    },
  })

  return {
    rowData: rowQuery.data,
    colConfig: colQuery.data,
    isLoading: rowQuery.isLoading || colQuery.isLoading,
    isError: rowQuery.isError || colQuery.isError,
  }
}
